<template>
    <settings-control label="Font">
        <dropdown
            theme="minimalistic"
            placeholder="Select Font"
            :options="options"
            :value="fontFamily"
            native
            @input="onInput"
        />
    </settings-control>
</template>

<script>
import SettingsControl from '@/components/settings/shared/settings-control';
import { tailwindConfig } from '@/data/tailwind';

const configValues = tailwindConfig.theme.fontFamily;

export default {
    name: 'settings-control-font-family',
    components: { SettingsControl },

    props: {
        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            fontFamily: this.value,
        };
    },

    computed: {
        options() {
            const defaultOption = { text: 'Default', value: '' };
            const fontFamilies = [];

            // filter out any duplicate font family values
            const fontOptions = Object.entries(configValues)
                .filter((entry) => {
                    const [, value] = entry;
                    const exists = fontFamilies.includes(value);

                    if (exists) return false;

                    fontFamilies.push(value);
                    return true;
                })
                .map((entry) => {
                    const [key] = entry;

                    return {
                        text: configValues[key],
                        value: configValues[key],
                    };
                });

            return [defaultOption].concat(fontOptions);
        },
    },

    watch: {
        value(newVal) {
            this.fontFamily = newVal;
        },
    },

    methods: {
        onInput(value) {
            this.fontFamily = value;

            this.$emit('input', {
                tailwindDefinitionProp: 'fontFamily',
                value,
            });
        },
    },
};
</script>
